import { useState, useEffect } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import StudentTimeLogsDetails from "./StudentTimeLogsDetails";
import StudentTimeLogsDetailsPdf from "./StudentTimeLogsDetailsPdf";

const StudentsList = ({ students, opportunities, timeLogs, isPDF = false }) => {
  const [expandedStudents, setExpandedStudents] = useState(new Set());

  useEffect(() => {
    if (isPDF) {
      const allStudentIds = new Set(
        students.map((student) => student.studentId)
      );
      setExpandedStudents(allStudentIds);
    } else {
      setExpandedStudents(new Set());
    }
  }, [isPDF, students]);

  const handleStudentClick = (studentId) => {
    setExpandedStudents((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(studentId)) {
        newSet.delete(studentId);
      } else {
        newSet.add(studentId);
      }
      return newSet;
    });
  };

  // Sort students by last name
  const sortedStudents = students.sort((a, b) => {
    return a.lastName.localeCompare(b.lastName);
  });

  return (
    <div className="space-y-4">
      {sortedStudents.map((student) => (
        <div
          key={student.studentId}
          className="border border-gray-200 rounded-lg overflow-hidden"
          data-student-container
        >
          <button
            onClick={() => handleStudentClick(student.studentId)}
            className={`w-full px-4 py-3 ${
              isPDF ? "pb-4" : "hover:bg-gray-50 transition-colors"
            } flex items-center justify-between bg-white`}
            data-student-button
          >
            <div className="flex items-center space-x-3">
              {!isPDF && expandedStudents.has(student.studentId) ? (
                <ChevronDown className="w-5 h-5 text-gray-500" />
              ) : (
                !isPDF && <ChevronRight className="w-5 h-5 text-gray-500" />
              )}

              <div className="text-left">
                <h3 className="font-medium text-gray-900">
                  {student.firstName} {student.lastName}
                </h3>
                <p className="text-sm text-gray-500">
                  {student.program} - {student.cohort}
                </p>
              </div>
            </div>
            <div className="text-sm text-gray-500">
              Student ID: {student.studentId}
            </div>
          </button>

          <div
            className={`border-t border-gray-200 p-4 bg-gray-50`}
            data-student-details
            style={{
              display: expandedStudents.has(student.studentId)
                ? undefined
                : "none",
            }}
          >
            {isPDF ? (
              <StudentTimeLogsDetailsPdf
                student={student}
                studentTimeLogs={timeLogs.filter(
                  (log) => log.studentId === student.studentId
                )}
                studentOpportunities={opportunities.filter(
                  (opportunity) =>
                    opportunity.students &&
                    opportunity.students.includes(student.studentId)
                )}
              />
            ) : (
              <StudentTimeLogsDetails
                student={student}
                studentTimeLogs={timeLogs.filter(
                  (log) => log.studentId === student.studentId
                )}
                studentOpportunities={opportunities.filter(
                  (opportunity) =>
                    opportunity.students &&
                    opportunity.students.includes(student.studentId)
                )}
              />
            )}
          </div>
        </div>
      ))}

      {students.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          No students match the selected filters.
        </div>
      )}
    </div>
  );
};

export default StudentsList;
